// Contact — page statique publique avec liens externes

import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft, ExternalLink, Mail } from 'lucide-react'
import { LogoPreventionScop } from '../components/layout'
import { Separator } from '../components/ui/separator'
import { Card, CardContent } from '../components/ui/card'

export default function ContactPage() {
  useEffect(() => { window.scrollTo(0, 0) }, [])
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-white">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/">
            <LogoPreventionScop className="h-8 w-auto" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="size-4" />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      {/* Contenu */}
      <main className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-2">Contact</h1>
        <p className="text-sm text-muted-foreground mb-8">
          Pour toute question relative à Diag SCOP Prévention, vous pouvez nous contacter
          via les canaux suivants.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
          {/* Carte PréventionBTP */}
          <a
            href="https://www.preventionbtp.fr"
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <Card className="h-full hover:border-primary/30 hover:shadow-md transition-all cursor-pointer group">
              <CardContent className="p-6 flex flex-col gap-3">
                <div className="flex items-center justify-between">
                  <span className="text-base font-semibold group-hover:text-primary transition-colors">
                    PréventionBTP
                  </span>
                  <ExternalLink className="size-4 text-muted-foreground group-hover:text-primary transition-colors" />
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Ressources prévention, support technique, espace e-prévention.
                </p>
              </CardContent>
            </Card>
          </a>

          {/* Carte OPPBTP */}
          <a
            href="https://www.oppbtp.com/contact/"
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <Card className="h-full hover:border-primary/30 hover:shadow-md transition-all cursor-pointer group">
              <CardContent className="p-6 flex flex-col gap-3">
                <div className="flex items-center justify-between">
                  <span className="text-base font-semibold group-hover:text-primary transition-colors">
                    OPPBTP
                  </span>
                  <ExternalLink className="size-4 text-muted-foreground group-hover:text-primary transition-colors" />
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Contact général, questions institutionnelles, partenariats.
                </p>
              </CardContent>
            </Card>
          </a>
        </div>

        <Separator className="my-8" />

        {/* Email direct */}
        <div className="flex items-center gap-3 text-sm text-muted-foreground">
          <Mail className="size-4 flex-shrink-0" />
          <span>
            Vous pouvez également nous écrire à{' '}
            <a href="mailto:cn@oppbtp.fr" className="text-primary hover:underline">cn@oppbtp.fr</a>
          </span>
        </div>
      </main>
    </div>
  )
}
